import CryptoJS from "crypto-js";

/**
 * Criptografa o input (base64) para uma chave HMAC em formato hexadecimal.
 * @param {string} base64Content Configuração do gráfico encodada em base64. 
 * @returns {string} Hash único utilizando o padrão HMAC.
 */
export const createBase64Signature = function (base64Content) {
  const _sK = process.env.REACT_APP_CHART_EXPORTER_SECRET_KEY;
  // Converter a chave secreta e o valor base64 para objetos WordArray do CryptoJS
  const key = CryptoJS.enc.Base64.parse(_sK);
  const value = CryptoJS.enc.Base64.parse(base64Content);

  // Calcular o HMAC usando a função CryptoJS.HmacMD5
  const hmac = CryptoJS.HmacMD5(value, key);

  // Converter o resultado do HMAC para uma string em formato hexadecimal
  const hmacHex = hmac.toString(CryptoJS.enc.Hex);

  return hmacHex;
};
